import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0c6f40a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "complaint-layout"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "infringement-title"
}, [/*#__PURE__*/_createElementVNode("h4", null, "侵权投诉")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "complaint-hint --van-doc-text-color-1"
}, " 如果有内容侵犯了您的合法权益：名称、商标被冒用，版权、隐私、肖像被侵犯等，可以将相关证明资料发送到18266239106@163.com邮箱，由我们专人进行处理。 ", -1));
const _hoisted_4 = {
  style: {
    "margin": "20px"
  }
};
import { onMounted } from "vue";
import useClipboard from "vue-clipboard3";
import { showSuccessToast } from "vant";
export default {
  __name: 'ComplaintInfringementComponents',
  setup(__props) {
    const {
      toClipboard
    } = useClipboard();
    onMounted(() => {
      document.title = '侵权投诉';
    });
    const submit = async () => {
      const copyStr = '18266239106@163.com';
      try {
        await toClipboard(copyStr);
        showSuccessToast('复制成功');
      } catch (e) {
        console.log('copy error', e);
      }
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_button, {
        type: "success",
        block: "",
        onClick: submit
      }, {
        default: _withCtx(() => [_createTextVNode("复制邮箱")]),
        _: 1
      })])]);
    };
  }
};